var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPen = function SvgPen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.256 14.422 13 6.678 9.322 3l-7.744 7.744a.84.84 0 0 0-.22.387L.5 15.5l4.368-.858a.84.84 0 0 0 .388-.22M15.5 4.178a1.666 1.666 0 0 0 0-2.356L14.178.5a1.667 1.667 0 0 0-2.356 0L10.5 1.822 14.178 5.5z"
  })));
};
export default SvgPen;